import { FunctionComponent, useEffect, useState, PureComponent } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Guid } from "../../../api/baseApi";
import { TimeSlotModel, getBaseChannels } from "../../../api/channelsApi";
import { getMedia, getMediaPlayout, MediaModel, MediaPlayout, MediaPlayoutRequest, MediaType } from "../../../api/mediaApi";
import { addBackgroundImage, addBespokeImage, deleteDownloadTimeslot, deleteSkinTimeslot, DownloadTimeslotRequest, DownloadTimeslotResponse, forceIrCommand, getDownloadTimeslots, getMediaForPlayer, getPlayerAudioDevices, getPlayerConfiguration, getPlayerHealth, getPlayerLogs, getPlayerScheduleOverride, getPlayerTechProfile, getPlayerVideoDevices, getScreenshots, getSkinTimeslots, HealthStatisticEntry, PlayerDevice, PlayerLog, PlayerTimeSlotOverrideModel, PlayerTimeSlotOverrideRequest, postDownloadTimeslots, postPlayerScheduleOverride, postSkinTimeslots, restartPlayer, ScreenShot, sendSkyQCommand, SendSkyQCommandRequest, SkinTimeslotRequest, SkinTimeslotResponse, SkyQCommandType, takeScreenshot, UpdateConfigurationRequest, updateConfuguration, UpdatePlayerTechProfileRequest, updateTechProfile } from "../../../api/playersApi";
import { createTag, getTags } from "../../../api/tagApi";
import { converFromBytes, getYoutubeImageUrlById } from "../../../services/common";
import { areDatesEqual, convertUTCDateToLocalDateMMDDYY, currentDateString, currentDateTimeString, currentDateTimeStringLocale, dateTimeString, formatDate, formatTime, formatTimeOnly, getDateBefore, getDateBeforeLocale, getPastDateByDaysAgo } from "../../../services/dateService";
import { Button } from "../../components/Button";
import DescriptionList from "../../components/descriptionList/descriptionList";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import FormMultiSelect from "../../components/formRow/FormMultiSelect";
import FormRange from "../../components/formRow/FormRange";
import { FormInput, FormInputNumber, FormInputTextarea, FormRow, FormRowHorizontal, FormSelect, SelectOption } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import Tabs, { TabElement, TabNavigation, TabNavigationElement, TabsContainer } from "../../components/tab/Tab";
import InnerLayout from "../innerLayout/InnerLayout";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { CenterModal, SmallModal } from "../../components/sideModal/Modal";
import { getMosaicList } from "../../../api/mosaicApi";
import TvChannelMappingOverrides from "../../components/tvChannelMapping/TvChannelMappingOverrides";
import { currentUserHasPermission, Permission } from "../../../api/authApi";
import Select, { SingleValue } from "react-select";
import { TVProfile, getTVProfiles } from "../../../api/tvChannelApi";
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";
import moment from "moment";
import { MediaTranscodingProfile, getTranscodingProfiles } from "../../../api/mediaTranscodingApi";
import VolumeProfiles from "../../components/volumeProfiles/VolumeProfiles";
import Schedule from "../../components/schedule/Schedule";
import ScheduleOverride from "../../components/schedule/ScheduleOverride";
import Advertising from "../../components/advertising/Advertising";
import Privacy from "../../components/privacy/Privacy";
import ReachTracker from "../../components/reachTracker/ReachTracker";
import PlayNowOffline from "../../components/playNowOffline/playNowOffline";
import { WeekDays } from "../../../api/priorityListApi";
import { config } from "process";


interface PlayerDetailsParams{
    id: string;
}

interface PlayerDetailsProps {
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}
 
type PlayerTab = "techProfile" | 
                 "configuration" | 
                 "logs" | 
                 "health" | 
                 "screenshots" | 
                 "media" | 
                 "tvChannelOverrides" | 
                 "volumeProfiles" | 
                 "dayPartingOverride" |
                 "advertising" |
                 "privacy" | 
                 "reachTracker" |
                 "playnowOffline";

let weekDaysStart: WeekDays = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false
}

const PlayerDetails: FunctionComponent<PlayerDetailsProps> = (props: PlayerDetailsProps) => {
    let [ activeTab, setActiveTab ] = useState<PlayerTab>("techProfile");
    let [ playerStatus, setPlayerStatus ] = useState<boolean>(false);
    let [ newPlayerTag, setNewPlayerTag ] = useState<string>("");
    let [ tags, setTags ] = useState<Guid[]>([]);
    let [ channelId, setChannelId ] = useState<Guid>("");
    let [ tagsOptions, setTagsOptions ] = useState<SelectOption[]>([]);
    let [ сhannelOptions, setChannelOptions ] = useState<SelectOption[]>([]);
    let [ defaultImage, setDefaultImage ] = useState<string>("");
    let [ volume, setVolume ] = useState<number>(0);
    let [ showSize, setShowSize] = useState<string>('');
    let [ showAspectRation, setShowAspectRatio] = useState<string>('');
    let [ isStreamEnabled, setIsStreamEnabled] = useState<boolean>(false);
    let [ skinId, setSkinId] = useState<Guid>("");
    let [ skinOptions, setSkinOptions ] = useState<SelectOption[]>([]);
    let [ chromaFormat, setChromaFormat] = useState<string>('');
    let [ skyQIP, setSkyQIP] = useState<string>('');
    let [ isSkyQIPError, setIsSkyQIPError] = useState(false);

    let [ audioDelay, setAudioDelay] = useState<number | ''>(0);

    let [ playerName, setPlayerName] = useState<string>("");
    let [ playerIP, setPlayerIP] = useState("");
    let [ playerUserAgent, setPlayerUserAgent] = useState("");
    let [ location, setLocation] = useState<string>("");
    let [ postalCode, setPostalCode] = useState<string>("");
    let [ clientNote, setClientNote] = useState<string>("");
    let [ playerId, setPlayerId] = useState<string>("");
    let [ horizontalResolution, setHorizontalResolution] = useState<number>(0);
    let [ verticalResolution, setVerticalResolution] = useState<number>(0);
    let [ totalDiskSpace, setTotalDiskSpace] = useState<number>(0);
    let [ availableDiskSpace, setAvailableDiskSpace] = useState<number>(0);
    let [ version, setVersion] = useState<string>("");

    let [ playerLogs, setPlayerLogs] = useState<PlayerLog[]>([]);
    let [ currentPage, setCurrentPage] = useState<number>(1);
    let [ totalPages, setTotalPages] = useState<number>(0);

    let [ isLoading, setIsLoading] = useState(false); 

    let { id } = useParams<PlayerDetailsParams>();

    let [spaceUsage, setSpaceUsage] = useState<HealthStatisticEntry[]>([]);
    let [totalSpace, setTotalSpace] = useState<number>(1);
    let [heartBeats, setHeartBeats] = useState<HealthStatisticEntry[]>([]);
    let [gpuUsage, setGpuUsage] = useState<HealthStatisticEntry[]>([]);
    let [cpuUsage, setCpuUsage] = useState<HealthStatisticEntry[]>([]);
    let [ram, setRam] = useState<HealthStatisticEntry[]>([]);
    let [totalRam, setTotalRam] = useState<number>(0);
    let [selectedStartDate, setSelectedStartDate] = useState<string>(getPastDateByDaysAgo(1,true));
    let [selectedEndDate, setSelectedEndDate] = useState<string>(getPastDateByDaysAgo(0,true));

    let [showScreenModal, setShowScreenModal] = useState<boolean>(false);
    let [screenshots, setScreenshots] = useState<ScreenShot[]>([]);
    let [screenshotFilterDate, setScreenshotFilterDate] = useState(moment(getPastDateByDaysAgo(0)));
    let [currentScreenShot, setCurrentScreenShot] = useState<ScreenShot>();

    let [playerMedia, setPlayerMedia] = useState<MediaModel[]>([]);
    let [playouts, setPlayouts] = useState<MediaPlayout[]>([]);
    let [currentPagePaginationMedia, setCurrentPagePaginationMedia] = useState(1);

    let [isShowScheduleModal, setIsShowScheduleModal] = useState(false);
    let [skinTimeslots, setSkinTimeslots] = useState<SkinTimeslotResponse[]>([]);
    let [isPeriodStartError, setIsPeriodStartError] = useState(false);
    let [isPeriodEndError, setIsPeriodEndError] = useState(false);
    let [periodStart, setPeriodStart] = useState('');
    let [periodEnd, setPeriodEnd] = useState('');
    let [periodName, setPeriodName] = useState('');
    let [isPeriodNameError, setIsPeriodNameError] = useState(false);

    let [videoDeviceList, setVideoDeviceList] = useState<PlayerDevice[]>([]);
    let [selectedVideoDevice, setSelectedVideoDevice] = useState<SingleValue<PlayerDevice>>();
    let [isVideoDeviceError, setIsVideoDeviceError] = useState(false);
    let [wrongVideoDevice, setWrongVideoDevice] = useState<string | null>('');
    let [audioDeviceList, setAudioDeviceList] = useState<PlayerDevice[]>([]);
    let [selectedAudioDevice, setSelectedAudioDevice] = useState<SingleValue<PlayerDevice>>();
    let [isAudioDeviceError, setIsAudioDeviceError] = useState(false);
    let [wrongAudioDevice, setWrongAudioDevice] = useState<string | null>('');

    let baseADevices = [{name: 'Default'},{name: 'None'}];
    let baseVDevices = [{name: 'Default'}];

    let [playerMappingProfileId, setPlayerMappingProfileId] = useState<Guid | null>(null);
    let [tvProfilesList, setTvProfilesList] = useState<TVProfile[]>([]);
    let [selectedTvProfile, setSelectedTvProfile] = useState<SingleValue<TVProfile>>(null);
    let [isSelectedTvProfileError, setIsSelectedTvProfileError] = useState(false);

    let [isShowRestartModal,setIsShowRestartModal] = useState(false);

    let [transcodingProfiles, setTranscodingProfiles] = useState<MediaTranscodingProfile[]>([]);
    let [selectedTranscodingProfile, setSelectedTranscodingProfile] = useState<SingleValue<MediaTranscodingProfile>>(null);
    let [currentTranscodingId, setCurrentTranscodingId] = useState<Guid | null>(null);

    let [useProxyServer, setUseProxyServer ] = useState(false);

    let [bespokeImage, setBespokeImage ] = useState("");
    let [isBespokeImageEnabled, setIsBespokeImageEnabled] = useState(false);
    let [timeSlots, setTimeSlots] = useState<PlayerTimeSlotOverrideModel[]>([]);

    let [isDownloadTimeEnable, setIsDownloadTimeEnable] = useState(false);
    let [isShowDownloadTimeModal, setIsShowDownloadTimeModal] = useState(false);
    let [downloadTimeslots, setDownloadTimeslots] = useState<DownloadTimeslotResponse[]>([]);
    let [isDownloadStartDateError, setIsDownloadStartDateError] = useState(false);
    let [isDownloadEndDateError, setIsDownloadEndDateError] = useState(false);
    let [isDownloadStartTimeError, setIsDownloadStartTimeError] = useState(false);
    let [isDownloadEndTimeError, setIsDownloadEndTimeError] = useState(false);
    let [downloadStartDate, setDownloadStartDate] = useState('');
    let [downloadStartTime, setDownloadStartTime] = useState('');
    let [downloadEndDate, setDownloadEndDate] = useState('');
    let [downloadEndTime, setDownloadEndTime] = useState('');
    let [downloadName, setDownloadName] = useState('');
    let [isDownloadNameError, setIsDownloadNameError] = useState(false);
    let [downloadTimeWeekDays, setDownloadTimeWeekDays] = useState<WeekDays>(weekDaysStart);
    let [downloadTimeWeekDaysError, setDownloadTimeWeekDaysError] = useState(false);

    let [loudness, setLoudness] = useState<string | number | null>(null);
    let [dolbyLoudness, setDolbyLoudness] = useState<number | null>(1);
    let [isLoudnessError, setIsLoudnessError] = useState(false);
    let [truePeak, setTruePeak] = useState<string | number |null>(null);
    let [dolbyTruePeak, setDolbyTruePeak] = useState<number | null>(1);
    let [isTruePeakError, setIsTruePeakError] = useState(false);

    const pageLocation = useLocation<{startConfigure:boolean}>();

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            await getAllConfigurationValues()
            setIsLoading(false);
        } 
       
        fetchData();

        if(pageLocation.state && pageLocation.state.startConfigure){
            setActiveTab("configuration")
        }
    }, []);

    const getAllConfigurationValues = async () => {
            let getVideoDevicesPromise = getPlayerVideoDevices(id);
            let getAudioDevicesResult = getPlayerAudioDevices(id);
            let playerConfigurationResult = getPlayerConfiguration(id);

            await Promise.all([updateTVProfiles(), updateTags(), updateChannels(), updateMosaics(), getVideoDevicesPromise, getAudioDevicesResult, playerConfigurationResult, updateTranscodingProfiles(),]).then(
                (values) => {
                    let videoDeviceResult = values[4];
                    let audioDeviceResult = values[5];
                    let configurationResult = values[6];

                    let videoDevices: PlayerDevice[] = [];
                    if(videoDeviceResult.type == "succes"){
                        videoDevices = [...baseVDevices, ...videoDeviceResult.data.items];
                        setVideoDeviceList(videoDevices);
                    }
                    
                    let audioDevices: PlayerDevice[] = [];
                    if(audioDeviceResult.type == "succes"){
                        audioDevices = [...baseADevices, ...audioDeviceResult.data.items]
                        setAudioDeviceList(audioDevices)
                    }
                    
                    if(configurationResult.type == "succes"){

                        let videoDeviceFromConfiguration = getDeviceObject(configurationResult.data.dshowVdev);
                        if(!(videoDevices.some( it => it.name === videoDeviceFromConfiguration.name))){
                            setIsVideoDeviceError(true);
                            setWrongVideoDevice(configurationResult.data.dshowVdev);
                        }

                        let audioDeviceFromConfiguration = getDeviceObject(configurationResult.data.dshowAdev);
                        if(!(audioDevices.some( it => it.name === audioDeviceFromConfiguration.name))){
                            setIsAudioDeviceError(true);
                            setWrongAudioDevice(configurationResult.data.dshowAdev);
                        }

                        setTags(configurationResult.data.tags);
                        setPlayerStatus(configurationResult.data.isEnabled);
                        setChannelId(configurationResult.data.channelId ?? undefined);
                        setVolume(configurationResult.data.volume);
                        setDefaultImage(configurationResult.data.defaultImageUrl);
                        setShowSize(configurationResult.data.dshowSize);
                        setShowAspectRatio(configurationResult.data.dshowAspectRatio);
                        setIsStreamEnabled(configurationResult.data.isStreamEnabled);

                        setSelectedVideoDevice(getDeviceObject(configurationResult.data.dshowVdev));
                        setSelectedAudioDevice(getDeviceObject(configurationResult.data.dshowAdev));

                        setAudioDelay(configurationResult.data.audioDelay);
                        setChromaFormat(configurationResult.data.chromaFormat);
                        setSkinId(configurationResult.data.skinId ?? skinId);

                        setPlayerMappingProfileId(configurationResult.data.tvChannelMappingProfileId);
                        setCurrentTranscodingId(configurationResult.data.transcodeProfileId);

                        setLoudness(configurationResult.data.loudnessTargetLevel)
                        setDolbyLoudness(configurationResult.data.dolbyLoudnessTargetLevel)
                        setTruePeak(configurationResult.data.loudnessTruePeak)
                        setDolbyTruePeak(configurationResult.data.dolbyLoudnessTruePeak)

                        setUseProxyServer(configurationResult.data.useProxyServer);

                        setBespokeImage(configurationResult.data.bespokeImageUrl);
                        setIsBespokeImageEnabled(configurationResult.data.isBespokeImageEnabled);
                        setIsDownloadTimeEnable(configurationResult.data.isDownloadScheduleEnabled);
                        setSkyQIP(configurationResult.data.skyQIP);
                    };
                }
            )
    }

    useEffect(()=>{
        let t = tvProfilesList.find(it => it.id == playerMappingProfileId)
        let t2 = t ? t : null
        setSelectedTvProfile(t2)
    },[tvProfilesList,playerMappingProfileId])

    useEffect(()=>{
        let t = transcodingProfiles.find(it => it.id == currentTranscodingId)
        let t2 = t ? t : null
        setSelectedTranscodingProfile(t2)
    },[transcodingProfiles,currentTranscodingId])

    useEffect(()=>{
        playerMedia.length && fetchPlayouts();
    },[playerMedia])

    useEffect(() => {
        async function fetchPlayerLogs(){
            setIsLoading(true);
            var playerLogsResponse = await getPlayerLogs(id, 1);
            if(playerLogsResponse.type === "succes"){
               setPlayerLogs(playerLogsResponse.data.items);
               setCurrentPage(playerLogsResponse.data.page);
               setTotalPages(playerLogsResponse.data.totalPages);
            }
            setIsLoading(false);
        }

        if( activeTab == "techProfile"){
            fetchTechProfile();
        }
       
        if( activeTab == "logs"){
            fetchPlayerLogs();
        }
        if(activeTab == "health"){
            updatePlayerHealth();
        }
        if( activeTab == "screenshots"){
            fetchScreenshots(true);
        }

        if(activeTab == "media"){
            fetchMediaForPlayer();
        }

        if(activeTab == "dayPartingOverride"){
            fetchPlayerSchedule();
        }
    }, [activeTab])

    useEffect(()=>{
        setIsPeriodNameError(false)
    },[periodName])

    useEffect(()=>{
        setIsPeriodStartError(false);
        setIsPeriodEndError(false)
    },[periodStart, periodEnd])

    const updateTVProfiles = async () => {
        let getTvProfilesResult = await getTVProfiles();
        if( getTvProfilesResult.type === "succes") {
            setTvProfilesList(getTvProfilesResult.data.items);
        }
    }

    const updateTranscodingProfiles = async () => {
        let response = await getTranscodingProfiles();
        if( response.type === "succes") {
            setTranscodingProfiles(response.data.items);
        }
    }

    const updateTags = async () => {
        let getTagsResult = await getTags();    
        if(getTagsResult.type == "succes"){
            setTagsOptions(getTagsResult.data.items.map(it => { return {name: it.name, value: it.id}}));
        };
    }

    const updateChannels = async () => {
        let getChannelsResult = await getBaseChannels();
        if(getChannelsResult.type == "succes"){
            setChannelOptions(getChannelsResult.data.items.map(it => { return {name: it.name, value: it.id}}));
        }
    }

    const updateMosaics = async () => {
        let getSkinResult = await getMosaicList();
        if(getSkinResult.type == "succes"){
            setSkinOptions(getSkinResult.data.items.map( it => {return {name: `${it.name} (${it.columnsCount}x${it.rowsCount})`, value: it.id}}).sort((a,b) => a.name < b.name ? -1 : 1))
        }
    }

    const fetchTechProfile = async () => {
        setIsLoading(true);
        var playerTechProfileResult = await getPlayerTechProfile(id);
        if(playerTechProfileResult.type == "succes"){
            setPlayerName(playerTechProfileResult.data.playerName);
            setPlayerIP(playerTechProfileResult.data.ip);
            setPlayerUserAgent(playerTechProfileResult.data.userAgent);
            setLocation(playerTechProfileResult.data.location);
            setPostalCode(playerTechProfileResult.data.postalCode);
            setClientNote(playerTechProfileResult.data.clientNote ?? "");
            setPlayerId(playerTechProfileResult.data.playerId);
            setHorizontalResolution(playerTechProfileResult.data.horizontalResolution);
            setVerticalResolution(playerTechProfileResult.data.verticalResolution);
            setTotalDiskSpace(playerTechProfileResult.data.totalDiskSpace);
            setAvailableDiskSpace(playerTechProfileResult.data.availableDiskSpace);
            setVersion(playerTechProfileResult.data.version);
        }
        setIsLoading(false);
    }

    const  updatePlayerHealth = async () =>  {
        setIsLoading(true)
        var end = dateTimeString(new Date(selectedEndDate));
        var start = dateTimeString(new Date(selectedStartDate));
        var result = await getPlayerHealth(id, start, end);
        if(result.type == "succes"){

            let spaceUsage = !result.data.data.spaceUsage ? [] : 
                [...result.data.data.spaceUsage.map(it => ({value: it.value, dateTime: convertUTCDateToLocalDateMMDDYY(it.dateTime)}))];
            let heartbeats = !result.data.data.heartbeats ? [] : 
                [...result.data.data.heartbeats.map(it => ({value: it.value, dateTime: convertUTCDateToLocalDateMMDDYY(it.dateTime)}))];
            let cpuUsage = !result.data.data.cpuUsage ? [] : 
                [...result.data.data.cpuUsage.map(it => ({value: it.value, dateTime: convertUTCDateToLocalDateMMDDYY(it.dateTime)}))];
            let gpuUsage = !result.data.data.gpuUsage ? [] : 
                [...result.data.data.gpuUsage.map(it => ({value: it.value, dateTime: convertUTCDateToLocalDateMMDDYY(it.dateTime)}))];
            let ram = !result.data.data.ram ? [] : 
                [...result.data.data.ram.map(it => ({value: it.value, dateTime: convertUTCDateToLocalDateMMDDYY(it.dateTime)}))];

            setSpaceUsage(spaceUsage);
            setHeartBeats(heartbeats);
            setCpuUsage(cpuUsage);
            setGpuUsage(gpuUsage);
            setRam(ram);
            setTotalRam(result.data.data.totalRam);
            setTotalSpace(result.data.data.totalSpaceGB);
        }
        setIsLoading(false)
    }

    const fetchScreenshots = async (showLoader: boolean) => {
        showLoader && setIsLoading(true);
        let result = await getScreenshots(id);
        showLoader && setIsLoading(false)
        if(result.type === "succes") {
            if(result.data.items.length !== 0 && (screenshots.length === 0 || result.data.items[0].dateTime !== screenshots[0].dateTime)){
                setScreenshots(result.data.items);
                setScreenshotFilterDate(moment(getPastDateByDaysAgo(0)));
                return true;
            }
        }

        return false;
    }

    const fetchMediaForPlayer = async () => {
        setIsLoading(true);
        let result = await getMediaForPlayer(id);
        if(result.type === "succes") setPlayerMedia(result.data.items);
        setIsLoading(false);
    }

    const fetchPlayouts = async () => {
        let mediaIdsForPlayouts = playerMedia.map(it => it.id);
        let playoutRequest:MediaPlayoutRequest = {
            ids: mediaIdsForPlayouts,
            playerId: id
        }
        let playoutResponse = await getMediaPlayout(playoutRequest);
        if(playoutResponse.type === "succes") setPlayouts(playoutResponse.data.items);
    }

    const fetchPlayerSchedule = async () => {
        setIsLoading(true);
        let result = await getPlayerScheduleOverride(id);
        if(result.type === "succes") setTimeSlots(result.data.items)
        setIsLoading(false);
    }
 
    const checkActive = (tab: PlayerTab) =>  tab == activeTab;
    const addTag = (id: Guid)=> setTags([...tags, id]);
    const removeTag = (id: Guid) => setTags(tags.filter(it => it !== id));

    const createNewTag = async () => {
        setIsLoading(true);
        var createTagResult = await createTag({name: newPlayerTag});

        if(createTagResult.type == "succes"){
            setTagsOptions([...tagsOptions,{ name: newPlayerTag, value:  createTagResult.data.id }]);
            setNewPlayerTag("");
        }   
        setIsLoading(false);
    }

    const isValidIPv4 = (ip:string) => {
        const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/;
        return ipv4Regex.test(ip);
    }

    const onConfigurationUpdate = async () => {
        let isValid = true;

        if(skyQIP && !isValidIPv4(skyQIP)){
            isValid = false;
            setIsSkyQIPError(true)
            window.scrollTo({top: 0})
        }

        if(loudness !== null) {
            if(+loudness < -45 || +loudness > -8){
                setIsLoudnessError(true);
                isValid = false;
                window.scrollTo({top: 0})
            }
        }

        if(truePeak !== null) {
            if(+truePeak < -33 || +truePeak > 0.1){
                setIsTruePeakError(true);
                isValid = false;
                window.scrollTo({top: 0})
            }
        }

        if(!isValid){
            return
        }

        setIsLoading(true);
        let delay = audioDelay === '' ? 0 : audioDelay;
        var request: UpdateConfigurationRequest = { 
            tags: tags,
            channelId: channelId === '' ? null : channelId,
            isEnabled: playerStatus,
            volume: volume,
            dshowSize: showSize,
            dshowAspectRatio: showAspectRation,
            isStreamEnabled: isStreamEnabled,
            dshowVdev: getDeviceName(selectedVideoDevice),
            dshowAdev: getDeviceName(selectedAudioDevice),
            audioDelay: delay,
            chromaFormat: chromaFormat,
            skinId: skinId === '' ? null : skinId,
            tvChannelMappingProfileId: selectedTvProfile ? selectedTvProfile.id : null,
            transcodeProfileId: selectedTranscodingProfile ? selectedTranscodingProfile.id : null,
            loudnessTargetLevel: loudness !== null ? +loudness : null,
            loudnessTruePeak: truePeak !==null ? +truePeak : null,
            useProxyServer: useProxyServer,
            isBespokeImageEnabled: isBespokeImageEnabled,
            isDownloadScheduleEnabled: isDownloadTimeEnable,
            skyQIP: skyQIP
         };
        await updateConfuguration(id, request);
        await getAllConfigurationValues();
        setIsLoading(false);
    }

    const getDeviceName = (value : SingleValue<PlayerDevice> | undefined) => {
        if(value) {
            switch (value.name){
                case "Default" : return null;
                case "None" : return 'none'
                default: return value.name
            }
        } else return null
    }

    const getDeviceObject = (value : string | null) => {
        if(value) {
            switch (value){
                case "none" : return {name: "None"}
                default: return {name: value}
            }
        } else return {name: "Default"}
    }

    const onTechProfileUpdate = async () =>{
        setIsLoading(true);
        var request: UpdatePlayerTechProfileRequest = {
            playerName,
            ip: playerIP,
            userAgent: playerUserAgent,
            location,
            postalCode,
            clientNote,
        }
        await updateTechProfile(id, request);
        setIsLoading(false);
    }

    const onDefaultImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const formData = new FormData();
            formData.append("Image", event.target.files[0] );
            formData.append("PlayerId", id );
            var res = await addBackgroundImage(formData);
        };

        var playerConfigurationResult = await getPlayerConfiguration(id);
        if(playerConfigurationResult.type == "succes"){
            setDefaultImage(playerConfigurationResult.data.defaultImageUrl);
        };
    }

    const onBespokeImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const formData = new FormData();
            formData.append("Image", event.target.files[0] );
            formData.append("PlayerId", id );
            await addBespokeImage(formData);
        };

        var playerConfigurationResult = await getPlayerConfiguration(id);
        if(playerConfigurationResult.type == "succes"){
            setBespokeImage(playerConfigurationResult.data.bespokeImageUrl);
        };
    }

    const resetImage = async () => {
        const formData = new FormData();
        formData.append("PlayerId", id );
        var res = await addBackgroundImage(formData);

        var playerConfigurationResult = await getPlayerConfiguration(id);
        if(playerConfigurationResult.type == "succes"){
            setDefaultImage(playerConfigurationResult.data.defaultImageUrl);
        };
    }

    const changeActivePage = async (currentActivePage: number) => {
        let newPlayerLogs = await getPlayerLogs(id, currentActivePage);
        if(newPlayerLogs.type === "succes"){
            setPlayerLogs(newPlayerLogs.data.items)
        }
        setCurrentPage(currentActivePage);
    }

    const renderScreenshots = (screenshot: ScreenShot, i: number) =>{
        return <div className="screen" key={i}>
            <img className="screen-img" src={screenshot.screensShotPreviewUrl} alt="" onClick={()=>showScreenInModal(screenshot)} />
            <p className="screen-date">{formatDate(screenshot.dateTime)} {formatTime(screenshot.dateTime)}</p>
        </div>
    }

    const showScreenInModal = (screenShot: ScreenShot) => {
        setShowScreenModal(true);
        setCurrentScreenShot(screenShot)
    }

    const hideScreenModal = () =>{
        setShowScreenModal(false);
        setCurrentScreenShot({dateTime: '', screenShotUrl: '', screensShotPreviewUrl: ''});
    }

    function sleep(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const takeScreenShotAction = async () => {
        setIsLoading(true);
        await takeScreenshot(id);
        for(let i = 0; i< 10; i++){
            await sleep(1000);
            var isUpdated = await fetchScreenshots(false);
            if(isUpdated) break;
        }
        setIsLoading(false);
    }

    const renderFilterDates = (days: number = 6) => {
        let links = [];
        for ( let i = 0; i < days; i++) links.push(i);
        return links.map((it, i) => {
            let date = moment(getPastDateByDaysAgo(it));
            let isActiveDate = areDatesEqual(date, screenshotFilterDate);
            if(i){
                return <span className={`filter-item ${isActiveDate && "active"}`} key={i} onClick={()=> setScreenshotFilterDate(date)}>{date.format("D/M/YYYY")}</span>
            } else return <span className={`filter-item ${isActiveDate && "active"}`} key={i} onClick={()=> setScreenshotFilterDate(date)}>Today</span>
        })
    }

    const filterScreenshotsByDate = () => {
        let items = !!screenshotFilterDate ? screenshots.filter( it => areDatesEqual(screenshotFilterDate, moment(it.dateTime))) : screenshots;
        return items
    }

    const getScreenshotsToDisplay = () => {
        return filterScreenshotsByDate()
    }

    const renderMediaType = (media: MediaModel) => {
        switch(media.mediaType){
            case MediaType.Image : return `Image (${media.sizeMb}MB)`;
            case MediaType.Video : return `Video (${media.sizeMb}MB)`;
            case MediaType.VastUrl : return "VAST Url";
            case MediaType.Youtube : return "Youtube";
            case MediaType.YoutubeLive : return "Youtube Live";
        }
    }

    const renderMediaTypePreview = (media: MediaModel) => {
        switch(media.mediaType){
            case MediaType.Image : return <img className="media-img" src={media.previewLink} alt="" />;
            case MediaType.Video : return <img className="media-img" src={media.previewLink} alt="" />;
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return  <img className="media-img" src={media.previewLink} alt="" />;
            case MediaType.YoutubeLive : return  <img className="media-img" src={media.previewLink} alt="" />;
        }
    }

    const getCurrentPlayout = (id: Guid) => {
        let t = playouts.find(it => it.mediaId === id);
        if(!t){
            return 0
        }
        return t.count
    }

    const renderRow = (media: MediaModel, index:number) => {
        return <tr key={index}>
            <td>
                {renderMediaTypePreview(media)}
            </td>
            <td>
                <span>{media.name}</span>
            </td>  
            <td>{media.transcodeProfile}</td>        
            <td>
                {renderMediaType(media)}
            </td>
            <td>
                {formatDate(media.uploadTime)} {formatTime(media.uploadTime)}
            </td>
            <td>
                {playouts.length ? getCurrentPlayout(media.id) : "Loading..."}
            </td>
        </tr>
    }

    const playerMediaItemsPerPage = 10;
    const getMediaItemsToDisplay = () => {
        let startIndex = (currentPagePaginationMedia - 1)*playerMediaItemsPerPage;
        let finishIndex = startIndex + playerMediaItemsPerPage;
        return playerMedia.slice(startIndex, finishIndex) 
    }

    const setStartDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPeriodStart(event.target.value);
        setIsPeriodStartError(false);
    }

    const setEndDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPeriodEnd(event.target.value);
        setIsPeriodEndError(false);
    }

    const saveTimeslot = async () => {
        let isError = false;
        if(periodName === '') {
            setIsPeriodNameError(true);
            isError = true
        }

        if(periodStart === ''){
            setIsPeriodStartError(true)
            isError = true
        }

        if(periodEnd === ''){
            setIsPeriodEndError(true)
            isError = true
        }

        if(new Date(periodEnd) <= new Date(periodStart)){
            setIsPeriodEndError(true);
            isError = true
        }
        if(isError) return

        let request:SkinTimeslotRequest = {
            name: periodName,
            start: periodStart,
            end: periodEnd 
        }

        setIsLoading(true);
        let result = await postSkinTimeslots(request, id);
        if(result.type === "succes") {
            await updateSkinTimeslots();
        }
        setPeriodName('');
        setPeriodStart('');
        setPeriodEnd('');
        setIsLoading(false);
    }

    const removeTimeslot = async (slotId:Guid) => {
        setIsLoading(true)
        await deleteSkinTimeslot(id,slotId);
        await updateSkinTimeslots();
        setIsLoading(false);
    }

    const updateSkinTimeslots = async () => {
        let result = await getSkinTimeslots(id);
        if(result.type === "succes") {
            setSkinTimeslots(result.data.items.sort((a,b)=>{
                return new Date(a.start).getTime() - new Date(b.start).getTime()
            }))
        }
    }

    const openScheduleModal = async () => {
        setIsShowScheduleModal(true);
        setIsLoading(true);
        await updateSkinTimeslots();
        setIsLoading(false)
    }

    const closeScheduleModal = () => {
        setIsShowScheduleModal(false);
        setSkinTimeslots([]);
    }

    const onSelectedVideoDevice = (newValue: SingleValue<PlayerDevice>) => {
        setIsVideoDeviceError(false);
        setWrongVideoDevice('');
        setSelectedVideoDevice(newValue);
    }

    const onSelectedAudioDevice = (newValue: SingleValue<PlayerDevice>) => {
        setIsAudioDeviceError(false);
        setWrongAudioDevice('');
        setSelectedAudioDevice(newValue);
    }

    const onSelectedTvProfile = (newValue: SingleValue<TVProfile>) => {
        setIsSelectedTvProfileError(false);
        setSelectedTvProfile(newValue)
    }

    const onSelectedTranscodingProfile = (newValue: SingleValue<MediaTranscodingProfile>) => {
        setSelectedTranscodingProfile(newValue)
    }

    const renderTimeslotRow = (timeslots: SkinTimeslotResponse[]) => {
        return timeslots.map( it => {
            return <tr key={it.id}>
                <td>{it.name}</td>
                <td>{formatDate(it.start)} {formatTime(it.start)}</td>
                <td>{formatDate(it.end)} {formatTime(it.end)}</td>
                <td>
                    <IconButton type="delete" tooltipText="Delete" onClick={()=>{removeTimeslot(it.id)}}/>
                </td>
            </tr>
        })
    }

    const hideRestartModal = () => {
        setIsShowRestartModal(false);
    }

    const restartPlayerByRequest = async () => {
        setIsLoading(true);
        await restartPlayer(id)
        setIsShowRestartModal(false);
        setIsLoading(false);
    }

    const forceCommandToPlayer = async () => {
        setIsLoading(true);
        await forceIrCommand(id);
        setIsLoading(false);
    }

    const sendSkyQPowerCommand = async () => {
        setIsLoading(true);
        const request: SendSkyQCommandRequest = {
            command: SkyQCommandType.Power
        };
        await sendSkyQCommand(id, request);
        setIsLoading(false);
    }

    const timeSlotOverride = async (timeSlot:PlayerTimeSlotOverrideRequest) => {
        await postPlayerScheduleOverride(timeSlot, id)
        await fetchPlayerSchedule();
    }

    const updateDownloadTimeslots = async () => {
        let result = await getDownloadTimeslots(id);
        if(result.type === "succes") {
            setDownloadTimeslots(result.data.items.sort((a,b)=>{
                return new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
            }))
        }
    }

    const openDownloadTimeModal = async () => {
        setIsShowDownloadTimeModal(true);
        setIsLoading(true);
        await updateDownloadTimeslots();
        setIsLoading(false)
    }

    const closeDownloadTimeModal = () => {
        setIsShowDownloadTimeModal(false);
        setIsDownloadNameError(false);
        setIsDownloadStartDateError(false);
        setIsDownloadEndDateError(false);
        setIsDownloadStartTimeError(false);
        setIsDownloadEndTimeError(false);
        setDownloadName('');
        setDownloadStartDate('');
        setDownloadEndDate('');
        setDownloadStartTime('');
        setDownloadEndTime('');
        setDownloadTimeWeekDays(weekDaysStart);
        setDownloadTimeWeekDaysError(false);
        setDownloadTimeslots([]);
    }

    const setDownloadStartDateFn = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDownloadStartDate(event.target.value);
        setIsDownloadStartDateError(false);
    }

    const setDownloadEndDateFn = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDownloadEndDate(event.target.value);
        setIsDownloadEndDateError(false);
    }

    const setDownloadStartTimeFn = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDownloadStartTime(event.target.value);
        setIsDownloadStartTimeError(false);
    }

    const setDownloadEndTimeFn = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDownloadEndTime(event.target.value);
        setIsDownloadEndTimeError(false);
    }

    const renderDownloadTimeslotRow = (timeslots: DownloadTimeslotResponse[]) => {
        return timeslots.map( it => {
            return <tr key={it.id}>
                <td>{it.name}</td>
                <td>{formatDate(it.startDate)} - {formatDate(it.endDate)}</td>
                <td>{formatTimeOnly(it.startTime)} - {formatTimeOnly(it.endTime)}</td>
                <td>
                    <span className="table-week-days">
                        <span className="week-day">
                            <span>M</span>
                            <span>{it.monday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                        </span>
                        <span className="week-day">
                            <span>T</span>
                            <span>{it.tuesday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                        </span>
                        <span className="week-day">
                            <span>W</span>
                            <span>{it.wednesday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                        </span>
                        <span className="week-day">
                            <span>Th</span>
                            <span>{it.thursday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                        </span>
                        <span className="week-day">
                            <span>F</span>
                            <span>{it.friday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                        </span>
                        <span className="week-day">
                            <span>S</span>
                            <span>{it.saturday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                        </span>
                        <span className="week-day">
                            <span>Su</span>
                            <span>{it.sunday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                        </span>
                    </span>
                </td>
                <td>
                    <IconButton type="delete" tooltipPosition="left" tooltipText="Delete" onClick={()=>{removeDownloadTimeslot(it.id)}}/>
                </td>
            </tr>
        })
    }

    const removeDownloadTimeslot = async (slotId:Guid) => {
        setIsLoading(true)
        await deleteDownloadTimeslot(id,slotId);
        await updateDownloadTimeslots();
        setIsLoading(false);
    }

    const renderWeekDaysInModal = (downloadTimeDays: WeekDays) => {
        let d = [];
        for (let day in downloadTimeDays) {
            d.push({
                day: day as keyof WeekDays,
                firstThreeChar: day.slice(0,3),
                isActive: downloadTimeDays[`${day as keyof WeekDays}`]
            })
        }

        return d.map( (it,i) => {
            return <span key={i} className="week-days" onClick={() => changeDownloadTimeDayActivity(it.day, it.isActive)}>
                <SvgSelector title={`${it.isActive ? 'ok' : 'cross'}`} />&nbsp; {it.firstThreeChar} &nbsp;
            </span>
        }) 
    }

    const changeDownloadTimeDayActivity = (day: keyof WeekDays, isActive: boolean) => {
        switch(day){
            case "monday" : 
                setDownloadTimeWeekDays({...downloadTimeWeekDays, monday: !isActive});
                break;
            case "tuesday" : 
                setDownloadTimeWeekDays({...downloadTimeWeekDays, tuesday: !isActive});
                break;
            case "wednesday" : 
                setDownloadTimeWeekDays({...downloadTimeWeekDays, wednesday: !isActive});
                break;
            case "thursday" : 
                setDownloadTimeWeekDays({...downloadTimeWeekDays, thursday: !isActive});
                break;
            case "friday" : 
                setDownloadTimeWeekDays({...downloadTimeWeekDays, friday: !isActive});
                break;
            case "saturday" : 
                setDownloadTimeWeekDays({...downloadTimeWeekDays, saturday: !isActive});
                break;
            case "sunday" : 
                setDownloadTimeWeekDays({...downloadTimeWeekDays, sunday: !isActive});
                break;
        }
        setDownloadTimeWeekDaysError(false)
    }

    const saveDownloadTimeslot = async () => {
        let isError = false;
        if(downloadName === '') {
            setIsDownloadNameError(true);
            isError = true
        }

        if(downloadStartDate === ''){
            setIsDownloadStartDateError(true)
            isError = true
        }

        if(downloadEndDate === ''){
            setIsDownloadEndDateError(true)
            isError = true
        }

        if(downloadStartTime === ''){
            setIsDownloadStartTimeError(true)
            isError = true
        }

        if(downloadEndTime === ''){
            setIsDownloadEndTimeError(true)
            isError = true
        }

        let isAnyDayChecked = Object.values(downloadTimeWeekDays).some(day => day === true)
        if(!isAnyDayChecked){
            setDownloadTimeWeekDaysError(true)
            isError = true
        }

        if(new Date(downloadEndDate) <= new Date(downloadStartDate)){
            setIsDownloadEndDateError(true);
            isError = true
        }

        if(isError) return

        let request:DownloadTimeslotRequest = {
            name: downloadName,
            startDate: downloadStartDate,
            endDate: downloadEndDate,
            startTime: downloadStartTime,
            endTime: downloadEndTime,
            ...downloadTimeWeekDays
        }

        setIsLoading(true);
        let result = await postDownloadTimeslots(request, id);
        if(result.type === "succes") {
            await updateDownloadTimeslots();
        }
        setDownloadName('');
        setDownloadStartDate('');
        setDownloadEndDate('');
        setDownloadStartTime('');
        setDownloadEndTime('');
        setDownloadTimeWeekDays(weekDaysStart);
        setIsLoading(false);
    }

    const loudnessHandler = (newValue: string) => {
        if(newValue === "") setLoudness(null);
        else setLoudness(+newValue);
        setIsLoudnessError(false);
    }

    const truePeakHandler = (newValue: string) => {
        if(newValue === "") setTruePeak(null)
        else setTruePeak(+newValue);
        setIsTruePeakError(false);
    }
 
    return ( <>
        <InnerLayout
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="players">
            <>
                <div style={{ paddingTop: '30px' }}>
                    <h2>Player Details</h2>
                </div>
                <Tabs>
                    <TabNavigation>
                        <TabNavigationElement title="Profile" isActive={checkActive("techProfile")} onClick={() => { setActiveTab("techProfile") }} />
                        <TabNavigationElement title="Configuration" isActive={checkActive("configuration")} onClick={() => { setActiveTab("configuration") }} />
                        <TabNavigationElement title="Logs" isActive={checkActive("logs")} onClick={() => { setActiveTab("logs") }} />
                        <TabNavigationElement title="Health" isActive={checkActive("health")} onClick={() => { setActiveTab("health") }} />
                        <TabNavigationElement title="Screenshots" isActive={checkActive("screenshots")} onClick={() => { setActiveTab("screenshots") }} />
                        <TabNavigationElement title="Media" isActive={checkActive("media")} onClick={() => { setActiveTab("media") }} />
                        <>
                            {
                                currentUserHasPermission(Permission.Settings) && <TabNavigationElement title="TV Channel Mapping Overrides" isActive={checkActive("tvChannelOverrides")} onClick={() => { setActiveTab("tvChannelOverrides") }} />
                            }
                        </>
                        <TabNavigationElement title="Volume Profiles" isActive={checkActive("volumeProfiles")} onClick={() => { setActiveTab("volumeProfiles") }} />
                        <TabNavigationElement title="Day Parting Override" isActive={checkActive("dayPartingOverride")} onClick={() => { setActiveTab("dayPartingOverride") }} />
                        <TabNavigationElement title="Advertising" isActive={checkActive("advertising")} onClick={() => { setActiveTab("advertising") }} />
                        <TabNavigationElement title="Privacy" isActive={checkActive("privacy")} onClick={() => { setActiveTab("privacy") }} />
                        <TabNavigationElement title="Reach Tracker" isActive={checkActive("reachTracker")} onClick={() => { setActiveTab("reachTracker") }} />
                        <TabNavigationElement title="PlayNow Offline" isActive={checkActive("playnowOffline")} onClick={() => { setActiveTab("playnowOffline") }} />
                    </TabNavigation>
                    <TabsContainer>
                        <TabElement isActive={checkActive("techProfile")}>
                            <div className="tech-profile-block">
                                <FormRowHorizontal>
                                    <label>&nbsp;</label>
                                    <div className="btn-group">
                                        <Button color="green" label="Restart Player" onClick={()=>{setIsShowRestartModal(true)}} />
                                 
                                        <Button color="green" label="Send IR Signal" onClick={forceCommandToPlayer} />
                                        
                                        <Button color="green" label="SKY Q Power" onClick={sendSkyQPowerCommand} />
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="player-name"
                                        title="Player Name"
                                        isError={false}
                                        errorMessage="Please enter player name"
                                        value={playerName}
                                        onChange={e => setPlayerName(e.target.value)}
                                    />
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="player-ip"
                                        title="IP"
                                        isError={false}
                                        errorMessage="Please enter player IP"
                                        value={playerIP}
                                        onChange={e => setPlayerIP(e.target.value)}
                                    />

                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="player-user-agent"
                                        title="User Agent"
                                        isError={false}
                                        errorMessage="Please enter player user agent"
                                        value={playerUserAgent}
                                        onChange={e => setPlayerUserAgent(e.target.value)}
                                    />

                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="location"
                                        title="Location"
                                        isError={false}
                                        errorMessage="Location invalid"
                                        value={location}
                                        onChange={e => setLocation(e.target.value)}
                                    />

                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="postal-code"
                                        title="Postal code"
                                        isError={false}
                                        errorMessage="Please enter postal code"
                                        value={postalCode}
                                        onChange={e => setPostalCode(e.target.value)}
                                    />

                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInputTextarea
                                        id="client-note"
                                        title="Note"
                                        isError={false}
                                        errorMessage="Please enter Note"
                                        value={clientNote}
                                        onChange={e => setClientNote(e.target.value)}
                                    />
                                </FormRowHorizontal>

                                <DescriptionList title="Player ID" value={playerId} />
                                <DescriptionList title="Horizontal Resolution" value={horizontalResolution} />
                                <DescriptionList title="Vertical Resolution" value={verticalResolution} />
                                <DescriptionList title="Total Disk Space" value={`${Math.round(converFromBytes(totalDiskSpace, "GB") * 100) / 100} GB`} />
                                <DescriptionList title="Avaliable Disk Space" value={`${Math.round(converFromBytes(availableDiskSpace, "GB") * 100) / 100} GB`} />
                                <DescriptionList title="Version" value={version} />
                                <div className="form-btn">
                                    <Button color="green" label="Save" onClick={onTechProfileUpdate} />
                                </div>
                            </div>
                        </TabElement>
                        <TabElement isActive={checkActive("configuration")}>
                            <div className="update-player-block">
                                <FormRowHorizontal>
                                    <FormSelect
                                        id="channel-assigment"
                                        title="Network Assignment"
                                        selectedValue={channelId}
                                        isError={false}
                                        errorMessage="Error"
                                        options={сhannelOptions}
                                        onChange={setChannelId}
                                    />
                                </FormRowHorizontal>
                                <div className="skin-schedule-pos">
                                <FormRowHorizontal>
                                    <FormSelect
                                        id="skin-assigment"
                                        title="Skin"
                                        selectedValue={skinId}
                                        isError={false}
                                        errorMessage="Error"
                                        options={skinOptions}
                                        onChange={setSkinId}
                                    />
                                </FormRowHorizontal>
                                {skinId && <IconButton type="clock" tooltipText="Schedule" onClick={() => {openScheduleModal()}} />}
                                </div>
                                <FormRowHorizontal>
                                    <label>TV Profile</label>
                                    <Select 
                                        className={`${isSelectedTvProfileError ? "error" : ""}`}
                                        classNamePrefix={`select`}
                                        options={tvProfilesList} 
                                        filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                        getOptionLabel={(option) => `${option.name}`}
                                        getOptionValue={(option) => `${option.id}`}
                                        onChange={onSelectedTvProfile}
                                        value={selectedTvProfile}
                                        isClearable
                                    />    
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="sky-q-ip"
                                        title="SkyQ IP"
                                        isError={isSkyQIPError}
                                        errorMessage="Please enter correct IP"
                                        value={skyQIP}
                                        placeholderTxt={"Enter IPv4 address (e.g. 192.168.1.1)"}
                                        onChange={e => {
                                            setIsSkyQIPError(false)
                                            setSkyQIP(e.target.value)
                                        }}
                                    />
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <label>Transcode Profile</label>
                                    <Select 
                                        className={`${isSelectedTvProfileError ? "error" : ""}`}
                                        classNamePrefix={`select`}
                                        options={transcodingProfiles} 
                                        filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                        getOptionLabel={(option) => `${option.name}`}
                                        getOptionValue={(option) => `${option.id}`}
                                        onChange={onSelectedTranscodingProfile}
                                        value={selectedTranscodingProfile}
                                        isClearable
                                    />    
                                </FormRowHorizontal>
                                <div className="form-row-with-right-text">
                                    <FormRowHorizontal>
                                        <FormInputNumber
                                            id="loudness"
                                            title="Adtag Overriden Target Level "
                                            isError={isLoudnessError}
                                            errorMessage="Select correct loudness in range -44 : -5.1"
                                            min={-44}
                                            max={-5.1}
                                            step={0.1}
                                            value={loudness !== null ? loudness : ""}
                                            onChange={()=>{}}
                                            onChangeValue={loudnessHandler}
                                        />
                                    </FormRowHorizontal>
                                    <div className="form-row-right-text">Assigned Transcode Profile Value: {dolbyLoudness === null ? "N/A" : dolbyLoudness}</div>
                                </div>
                                <div className="form-row-with-right-text">
                                    <FormRowHorizontal>
                                        <FormInputNumber
                                            id="true-peak"
                                            title="Adtag Overriden True Peak"
                                            isError={isTruePeakError}
                                            errorMessage="Select correct true peak in range -8.9 : -0.1"
                                            min={-8.9}
                                            max={-0.1}
                                            step={0}
                                            value={truePeak !== null ? truePeak : ""}
                                            onChange={()=>{}}
                                            onChangeValue={truePeakHandler}
                                        />
                                    </FormRowHorizontal>
                                    <div className="form-row-right-text">Assigned Transcode Profile Value: {dolbyTruePeak === null ? "N/A" : dolbyTruePeak}</div>
                                </div>
                                <FormRowHorizontal>
                                    <label>Player Status</label>
                                    <div className="status-container">
                                        <span className="status-block">
                                            {playerStatus ? <span className="current-status online">Enabled</span> : <span className="current-status offline">Disabled</span>}
                                        </span>
                                        <FormCheckbox id="player-status" checked={playerStatus} onChange={setPlayerStatus} />
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <label>Use Proxy Server</label>
                                    <div className="status-container">
                                        <span className="status-block">
                                            {useProxyServer ? <span className="current-status online">Enabled</span> : <span className="current-status offline">Disabled</span>}
                                        </span>
                                        <FormCheckbox id="use-proxy-server" checked={useProxyServer} onChange={setUseProxyServer} />
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="new-tag-name"
                                        title="New Player Tag"
                                        isError={false}
                                        errorMessage="Please enter player tag"
                                        value={newPlayerTag}
                                        onChange={e => setNewPlayerTag(e.target.value)}
                                    />
                                    <label>&nbsp;</label>
                                    <div className="form-btn-group" style={{ "paddingTop": "30px" }}>
                                        <Button color="green" label="Add tag" onClick={createNewTag} />
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormMultiSelect
                                        id="player-tags-list"
                                        title="Player Tags"
                                        titleSelected="Selected Tags"
                                        isError={false}
                                        errorMessage="Please select tag"
                                        onAdd={addTag}
                                        onRemove={removeTag}
                                        options={tagsOptions}
                                        selectedOptions={tags}
                                    />
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <label htmlFor="">Default image</label>
                                    <div className="avatar-container">
                                        {defaultImage &&
                                            <div className="avatar">
                                                <img className="avatar-img" src={defaultImage} alt="" />
                                            </div>}

                                        <div className="avatar-btn-group">
                                            <IconButton tooltipText="Reset image" type="refresh" roundedButton={true} onClick={resetImage} />
                                            <span>
                                                <label htmlFor="upload" className="icon_btn rounded"> <SvgSelector title={"plus"} /></label>
                                                <input type={"file"} id="upload" onChange={onDefaultImageChange} />
                                            </span>

                                        </div>
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormRange
                                        id="volume-range"
                                        title="Volume"
                                        min={0}
                                        max={200}
                                        step={1}
                                        value={volume}
                                        changeValue={setVolume}
                                    />
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <label htmlFor="">Holding Screen Image</label>
                                    <div className="avatar-container">
                                        {bespokeImage &&
                                            <div className="avatar">
                                                <img className="avatar-img" src={bespokeImage} alt="" />
                                            </div>}

                                        <div className="avatar-btn-group">
                                            <span>
                                                <label htmlFor="upload_second" className="icon_btn rounded"> <SvgSelector title={"plus"} /></label>
                                                <input type={"file"} id="upload_second" onChange={onBespokeImageChange} />
                                            </span>
                                        </div>
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <label>Use Holding Image</label>
                                    <div className="status-container">
                                        <span className="status-block">
                                            {isBespokeImageEnabled ? <span className="current-status online">Enable</span> : <span className="current-status offline">Disable</span>}
                                        </span>
                                        <FormCheckbox id="toggle-temp-image-status" checked={isBespokeImageEnabled} onChange={setIsBespokeImageEnabled} />
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="dshow-aspect-ratio"
                                        title="Aspect Ratio"
                                        isError={false}
                                        errorMessage="Please enter aspect ratio"
                                        value={showAspectRation}
                                        onChange={e => setShowAspectRatio(e.target.value)}
                                    />
                                </FormRowHorizontal>
                             
                                <FormRowHorizontal>
                                    <label>Stream</label>
                                    <div className="status-container">
                                        <span className="status-block">
                                            {isStreamEnabled ? <span className="current-status online">Enable</span> : <span className="current-status offline">Disable</span>}
                                        </span>
                                        <FormCheckbox id="stream-status" checked={isStreamEnabled} onChange={setIsStreamEnabled} />
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="dshow-size"
                                        title="Stream Dimension"
                                        isError={false}
                                        errorMessage="Please enter show size"
                                        value={showSize}
                                        onChange={e => setShowSize(e.target.value)}
                                    />
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <label>Stream Video Source</label>
                                    <div>
                                        <Select 
                                            classNamePrefix={`select`}
                                            options={videoDeviceList} 
                                            filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                            getOptionLabel={(option) => `${option.name}`}
                                            getOptionValue={(option) => `${option.name.trim().toLowerCase()}`}
                                            onChange={onSelectedVideoDevice}
                                            value={selectedVideoDevice}
                                        />  
                                        {isVideoDeviceError && <span className="error">{`Device ${wrongVideoDevice} is not available`}</span>}
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <label>Stream Audio Source</label>
                                    <div>
                                        <Select 
                                            classNamePrefix={`select`}
                                            options={audioDeviceList} 
                                            filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                            getOptionLabel={(option) => `${option.name}`}
                                            getOptionValue={(option) => `${option.name.trim().toLowerCase()}`}
                                            onChange={onSelectedAudioDevice}
                                            value={selectedAudioDevice}
                                        />  
                                        {isAudioDeviceError && <span className="error">{`Device ${wrongAudioDevice} is not available`}</span>}
                                    </div>
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInputNumber
                                        id="audio-delay"
                                        title="Audio Delay (ms)"
                                        isError={false}
                                        errorMessage="Please enter audio delay"
                                        value={audioDelay}
                                        onChange={e => {
                                            e.target.value === '' ? setAudioDelay('') : setAudioDelay(+e.target.value)
                                        }}
                                    />
                                </FormRowHorizontal>
                                <FormRowHorizontal>
                                    <FormInput
                                        id="chroma-format-input"
                                        title="Chroma Format"
                                        isError={false}
                                        errorMessage="Please enter ChromaFormat"
                                        value={chromaFormat}
                                        onChange={e => setChromaFormat(e.target.value)}
                                    />
                                </FormRowHorizontal>  

                                <FormRowHorizontal>
                                    <label>Media Download Schedule</label>
                                    <div className="status-container download-schedule-pos">
                                        <FormCheckbox id="download-time" checked={isDownloadTimeEnable} onChange={setIsDownloadTimeEnable} />
                                        {isDownloadTimeEnable ? <IconButton type="clock" tooltipText="" onClick={openDownloadTimeModal} /> : <span className="current-status offline">Disable</span>}
                                    </div>
                                </FormRowHorizontal>                              
                               
                                <div className="form-btn-group">
                                    <Button color="gray" label="Cancel" onClick={() => { }} />
                                    <Button color="green" label="Update Player" onClick={onConfigurationUpdate} />
                                </div>
                            </div>
                        </TabElement>
                        <TabElement isActive={checkActive("logs")}>
                            <>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <td>Event</td>
                                            <td>User</td>
                                            <td>Comment</td>
                                            <td>Date</td>
                                            <td>Time</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {playerLogs.map((it, i) => {
                                            return <tr key={i}>
                                                <td>{it.playerEvent}</td>
                                                <td>{it.user}</td>
                                                <td>{it.comment}</td>
                                                <td>{formatDate(it.dateTime)}</td>
                                                <td>{formatTime(it.dateTime)}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>

                                <Pagination activePage={currentPage} pagesCount={totalPages} changePaginationPage={changeActivePage} />
                            </>

                        </TabElement>
                        <TabElement isActive={checkActive("health")}>
                            <div className="chart-container">
                                <div className="chart-legends">
                                    <div className="filter-row">
                                        <div className="filter-group">

                                            <div className="generate-group">
                                                <FormRow>
                                                    <label>Start</label>
                                                    <input className="form-control" type="datetime-local" onChange={(e) => { setSelectedStartDate(e.target.value)}} value={selectedStartDate} min={getPastDateByDaysAgo(30, true)} ></input>
                                                </FormRow>
                                                <FormRow>
                                                    <label>End</label>
                                                    <input className="form-control" type="datetime-local" onChange={(e) => { setSelectedEndDate(e.target.value)}} value={selectedEndDate} min={selectedStartDate}></input>
                                                </FormRow>    
                                                <div className="">
                                                    <label style={{ "marginBottom": "4px", "display": "block" }} htmlFor="">&nbsp;</label>
                                                    <Button color="green" label="Update" onClick={updatePlayerHealth} />
                                                </div>                                                             
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="chart1">
                                    <div className="chart-title">Space Usage</div>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart
                                            width={500}
                                            height={300}
                                            data={spaceUsage}
                                            margin={{
                                                top: 0,
                                                right: 0,
                                                left: 0,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="0 0" />
                                            <XAxis dataKey="dateTime" />
                                            <YAxis dataKey="value" domain={[0, totalSpace]} />
                                            <Tooltip />
                                            <Legend />
                                            <Line type="monotone" dataKey="value" name="Used GB" stroke="#8884d8" />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="chart2">
                                    <div className="chart-title">CPU Usage</div>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart
                                            width={500}
                                            height={300}
                                            data={cpuUsage}
                                            margin={{
                                                top: 0,
                                                right: 0,
                                                left: 0,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="0 0" />
                                            <XAxis dataKey="dateTime" />
                                            <YAxis dataKey="value" domain={[0, 100]} />
                                            <Tooltip />
                                            <Legend />
                                            <Line type="monotone" dataKey="value" stroke="#8884d8" name="CPU Usage" />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="chart3">
                                    <div className="chart-title">GPU Usage</div>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart
                                            width={500}
                                            height={300}
                                            data={gpuUsage}
                                            margin={{
                                                top: 0,
                                                right: 0,
                                                left: 0,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="0 0" />
                                            <XAxis dataKey="dateTime" />
                                            <YAxis dataKey="value" domain={[0, 100]} />
                                            <Tooltip />
                                            <Legend />
                                            <Line type="monotone" dataKey="value" stroke="#8884d8" name="GPU Usage"/>
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="chart4">
                                    <div className="chart-title">Heartbeat</div>
                                    <ResponsiveContainer>
                                        <BarChart
                                            width={500}
                                            height={300}
                                            data={heartBeats}
                                            margin={{
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            }}
                                        >
                                            <CartesianGrid />
                                            <XAxis dataKey="dateTime" />
                                            <YAxis dataKey="value" />
                                            <Tooltip />
                                            <Legend />
                                            <Bar dataKey="value" fill="#ACE7A8" name="Pings"/>
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="chart4">
                                    <div className="chart-title">RAM Usage</div>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart
                                            width={500}
                                            height={300}
                                            data={ram}
                                            margin={{
                                                top: 0,
                                                right: 0,
                                                left: 0,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="0 0" />
                                            <XAxis dataKey="dateTime" />
                                            <YAxis dataKey="value" domain={[0, totalRam]}/>
                                            <Tooltip />
                                            <Legend />
                                            <Line type="monotone" dataKey="value" stroke="#8884d8" name="RAM Usage"/>
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>

                            </div>
                        </TabElement>
                        <TabElement isActive={checkActive('screenshots')}>
                            <>
                            <div className="d-flex align-self-stretch justify-content-between gap15 mb-20">
                                <Button color="green" label="Take Screenshot" onClick={takeScreenShotAction} />
                                <div className="d-flex gap5 align-items-center filter-date">
                                    {renderFilterDates(6)}
                                </div>
                            </div>
                            <div className="screenshots-block">
                                {getScreenshotsToDisplay().map(renderScreenshots)}
                            </div>
                            <CenterModal title={`${formatDate(currentScreenShot?.dateTime ?? "")} ${formatTime(currentScreenShot?.dateTime ?? "")}`} show={showScreenModal} onRequestClose={hideScreenModal}>
                                {currentScreenShot && <div className="screen">
                                    <img className="screen-img in-modal" src={currentScreenShot.screenShotUrl} alt="" />
                                </div>}
                            </CenterModal>
                            </>
                        </TabElement>
                        <TabElement isActive={checkActive('media')}>
                            <>
                            <table className="table media-table">
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td>File Name</td>
                                        <td>Transcode Profile</td>
                                        <td>Media Type</td>
                                        <td>Downloaded </td>
                                        <td>Playouts</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!!playerMedia && getMediaItemsToDisplay().map((m, i) => renderRow(m, i)) }
                                </tbody>
                            </table> 
                            {!!playerMedia.length && <Pagination activePage={currentPagePaginationMedia} pagesCount={getPagesCount(playerMedia.length, playerMediaItemsPerPage)} changePaginationPage={setCurrentPagePaginationMedia} />}
                            </>
                        </TabElement>
                        <TabElement isActive={checkActive('tvChannelOverrides')}>
                            { checkActive('tvChannelOverrides') ? <TvChannelMappingOverrides /> : <></>}
                        </TabElement>
                        <TabElement isActive={checkActive('volumeProfiles')}>
                            { checkActive('volumeProfiles') ? <VolumeProfiles /> : <></>}
                        </TabElement>
                        <TabElement isActive={checkActive('dayPartingOverride')}>
                            { checkActive('dayPartingOverride') ? <ScheduleOverride timeSlots={timeSlots} onTimeSlotClick={timeSlotOverride}/> : <></>}
                        </TabElement>
                        <TabElement isActive={checkActive('advertising')}>
                            { checkActive('advertising') ? <Advertising /> : <></>}
                        </TabElement>
                        <TabElement isActive={checkActive('privacy')}>
                            { checkActive('privacy') ? <Privacy /> : <></>}
                        </TabElement>
                        <TabElement isActive={checkActive('reachTracker')}>
                            { checkActive('reachTracker') ? <ReachTracker /> : <></>}
                        </TabElement>
                        <TabElement isActive={checkActive('playnowOffline')}>
                            { checkActive('playnowOffline') ? <PlayNowOffline /> : <></>}
                        </TabElement>
                        <GlobalSpinner isShow={isLoading} />
                    </TabsContainer>
                </Tabs>
                <CenterModal title="Skin Schedule" show={isShowScheduleModal} onRequestClose={closeScheduleModal}>
                    <div className="mosaic-period-wrapper">
                        <div className="mosaic-period-inputs">
                            <div>
                                <FormInput 
                                    errorMessage = "Please enter name"
                                    id = "period_name"
                                    isError = {isPeriodNameError}
                                    title = "Name"
                                    onChange = {(e)=>{setPeriodName(e.target.value)}}
                                    value = {periodName}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="start">Start</label>
                                <input 
                                    type="datetime-local" 
                                    className={`form-control ${isPeriodStartError ? "error" : ""}`}  
                                    name="" 
                                    id="start" 
                                    onChange={setStartDatePeriod}
                                    value={periodStart}
                                />
                                {isPeriodStartError && <span className="error">Please select start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends">End</label>
                                <input 
                                    type="datetime-local" 
                                    className={`form-control ${isPeriodEndError ? "error" : ""}`}  
                                    name="" 
                                    id="ends" 
                                    onChange={setEndDatePeriod}
                                    value={periodEnd}
                                    min={periodStart}
                                    disabled={!!!periodStart}
                                />
                                {isPeriodEndError && <span className="error">End period should be later than start period</span>}
                            </div>
                            <div className="">
                                <Button color="green" label="Add" onClick={()=>{saveTimeslot()}}/>
                            </div>
                        </div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>Start</td>
                                    <td>End</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {renderTimeslotRow(skinTimeslots)}
                            </tbody>
                        </table>
                    </div>
                </CenterModal>

                <CenterModal title="Media Download Schedule" show={isShowDownloadTimeModal} onRequestClose={closeDownloadTimeModal}>
                <div className="downloadtime-wrapper">
                        <div className="downloadtime-inputs">
                            <div>
                                <FormInput 
                                    errorMessage = "Please enter name"
                                    id = "download_name"
                                    isError = {isDownloadNameError}
                                    title = "Name"
                                    onChange = {(e)=>{setDownloadName(e.target.value); setIsDownloadNameError(false)}}
                                    value = {downloadName}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="start">Start Date</label>
                                <input 
                                    type="date" 
                                    className={`form-control ${isDownloadStartDateError ? "error" : ""}`}  
                                    name="" 
                                    id="download-start" 
                                    onChange={setDownloadStartDateFn}
                                    value={downloadStartDate}
                                />
                                {isDownloadStartDateError && <span className="error">Please select start date</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends">End Date</label>
                                <input 
                                    type="date" 
                                    className={`form-control ${isDownloadEndDateError ? "error" : ""}`}  
                                    name="" 
                                    id="download-ends" 
                                    onChange={setDownloadEndDateFn}
                                    value={downloadEndDate}
                                    min={downloadStartDate}
                                    disabled={!!!downloadStartDate}
                                />
                                {isDownloadEndDateError && <span className="error">End date should be later than start date</span>}
                            </div>
                            <div className="">
                                <label htmlFor="start">Start Time</label>
                                <input 
                                    type="time" 
                                    className={`form-control ${isDownloadStartTimeError ? "error" : ""}`}  
                                    name="" 
                                    id="download-start-time" 
                                    onChange={setDownloadStartTimeFn}
                                    value={downloadStartTime}
                                />
                                {isDownloadStartTimeError && <span className="error">Please select start time</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends">End Time</label>
                                <input 
                                    type="time" 
                                    className={`form-control ${isDownloadEndTimeError ? "error" : ""}`}  
                                    name="" 
                                    id="download-ends-time" 
                                    onChange={setDownloadEndTimeFn}
                                    value={downloadEndTime}
                                    min={downloadStartTime}
                                    disabled={!!!downloadStartTime}
                                />
                                {isDownloadEndTimeError && <span className="error">Please select end time</span>}
                            </div>
                            <div className="downloadtime-weekdays-row">
                                <div className="d-flex">
                                    {renderWeekDaysInModal(downloadTimeWeekDays)}
                                </div>
                                {downloadTimeWeekDaysError && <span className="error">Select at least one Day of the Week</span>}
                            </div>
                            <div className="">
                                <Button color="green" label="Add" onClick={saveDownloadTimeslot}/>
                            </div>
                        </div>
                        {downloadTimeslots.length ? <table className="table pt-30">
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>Date</td>
                                    <td>Time</td>
                                    <td>Days of week</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {renderDownloadTimeslotRow(downloadTimeslots)}
                            </tbody>
                        </table> : <></>}
                    </div>
                </CenterModal>

                <SmallModal show={isShowRestartModal} onRequestClose={hideRestartModal}> 
                    <p>That you want to Restart Player?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={hideRestartModal}/>
                        <Button color="green" label="Yes" onClick={() => {restartPlayerByRequest()}}/>
                    </div>
                </SmallModal>
            </>
        </InnerLayout>
    </> );
}
 
export default PlayerDetails;
